import { HttpHeaders } from '@angular/common/http';
import { SharedUtils } from './shared.utilities';
import { SERVER_URL, SOCKET_URL, EDIS_SERVER_URL, REST_SERVER_URL, SELECTED_VENDOR, CHART_SOCKET_URL, ANALYTICS_SERVER_URL, ROOT_URL } from '../../src/app/_helpers/constants';
import { PROD } from '../../src/app/_helpers/configuration';

class ApplicationUrls {
    private static appUrlsInstance: ApplicationUrls;
    public rootUrl: string;
    public serverUrl: string;
    public restServerUrl: string;
    public socketUrl: string;
    public serverUrlMarket: string;
    public serverUrlChart: string;
    public edisServerUrl: string;
    public analyticsServerUrl: string;

    public static getInstance(): ApplicationUrls {
        if (!ApplicationUrls.appUrlsInstance) {
            ApplicationUrls.appUrlsInstance = new ApplicationUrls();
            if (!PROD && SharedUtils.storageHelper.serverUrls) {
                ApplicationUrls.appUrlsInstance.restServerUrl = `${SharedUtils.storageHelper.serverUrls.restServer}`;
                ApplicationUrls.appUrlsInstance.serverUrl = `${SharedUtils.storageHelper.serverUrls.tradingServer}`;
                ApplicationUrls.appUrlsInstance.rootUrl = `${SharedUtils.storageHelper.serverUrls.rootUrl}`;
                ApplicationUrls.appUrlsInstance.serverUrlMarket = `${SharedUtils.storageHelper.serverUrls.socketServer}`;
                ApplicationUrls.appUrlsInstance.edisServerUrl = `${SharedUtils.storageHelper.serverUrls.edisServer}`;
                ApplicationUrls.appUrlsInstance.analyticsServerUrl = `${SharedUtils.storageHelper.serverUrls.analyticsServer}`;
            } else {
                ApplicationUrls.appUrlsInstance.restServerUrl = `${REST_SERVER_URL}`;
                ApplicationUrls.appUrlsInstance.serverUrl = `${SERVER_URL}`;
                ApplicationUrls.appUrlsInstance.rootUrl = `${ROOT_URL}`;
                ApplicationUrls.appUrlsInstance.serverUrlMarket = `${SOCKET_URL}`;
                ApplicationUrls.appUrlsInstance.serverUrlChart = `${CHART_SOCKET_URL}`;
                ApplicationUrls.appUrlsInstance.edisServerUrl = `${EDIS_SERVER_URL}`;
                ApplicationUrls.appUrlsInstance.analyticsServerUrl = `${ANALYTICS_SERVER_URL}`;
            }
        }
        return ApplicationUrls.appUrlsInstance;
    }

    private ApplicationUrls() { }

    get SOCKET_URL() {
        const url = new URL(this.serverUrl);
        return this.changeSocketProtocol(url);
    }

    get MARKET_DATA_URL() {
        const url = new URL(this.serverUrlMarket);
        return this.changeSocketProtocol(url);
    }

    get CHART_DATA_URL(){
        const url = new URL(this.serverUrlChart);
        return this.changeSocketProtocol(url);
    }

    get AI_SCREENER_URL() {
        const url = new URL(this.analyticsServerUrl);
        return this.changeSocketProtocol(url);
    }

    changeSocketProtocol(url: URL) {
        if (url.protocol === 'http:') {
            url.protocol = 'ws';
        } else {
            url.protocol = 'wss';
        }

        return url.toString();
    }
    public headers(otp?: string) {
        const userInfo = SharedUtils.storageHelper.userInfo;
        const headers = {};
        if (userInfo && userInfo.tokenType && userInfo.access_token) {
            headers['Authorization'] = userInfo.tokenType + ' ' + userInfo.access_token;
        }
        return new HttpHeaders(headers);
    }

    get socketAuthUrl() { return this.serverUrl + 'accounts/websocket_auth/'; }
    // Account Urls
    get userSignUpUrl() { return this.serverUrl + 'accounts/signup/'; }
    get loginUrl() { return this.serverUrl + 'accounts/login/'; }
    get tokenRefreshUrl() { return this.serverUrl + 'accounts/token_refresh/'; }
    get clientListUrl() { return this.serverUrl + 'accounts/clientlist/'; }
    get getPasswordPolicy() { return this.serverUrl + 'static_data/password_policy/'; }
    get logoutUrl() { return this.serverUrl + 'accounts/logout/'; }
    get signup() { return this.serverUrl + 'accounts/demo_account_register/'; }
    get emailConfirmationUrl() { return this.serverUrl + 'accounts/activate_demo_account/'; }
    get changePasswordUrl() { return this.serverUrl + 'accounts/login_password_reset/'; }
    get uccOtpLogin() { return this.serverUrl + 'accounts/v2/otp_login/'; }
    get recoverPasswordInitUrl() { return this.serverUrl + 'accounts/login_password_recover_init/'; }
    get verifyPAN() { return this.serverUrl + 'accounts/pan_verify/'; }
    get generateOtp() { return this.serverUrl + 'accounts/generate_otp_totp/' }
    get verifyOtpTotp() { return this.serverUrl + 'accounts/verify_otp_totp/' }
    get changePasswordInitializeUrl() { return this.serverUrl + 'accounts/login_password_reset_initialize/'; }
    get recoverPasswordUrl() { return this.serverUrl + 'accounts/login_password_recover/'; }
    get getPositionList() { return this.serverUrl + 'v2/orders/positions/'; }
    get verifyBiometric2FA() { return this.serverUrl + 'accounts/v2/otp_verify/'; }
    get verify2FA() { return this.serverUrl + 'accounts/v2/otp_verify/'; }
    get proceed2FA() { return this.serverUrl + 'accounts/proceed_login/'; }
    get setMPin() { return this.serverUrl + 'accounts/set_mpin/'; }
    get forgotMPin() { return this.serverUrl + 'accounts/forgot_mpin/'; }
    get loginHistory() { return this.serverUrl + 'accounts/login_history/'; }
    get userProfile() { return this.serverUrl + 'accounts/user_profile/'; }
    get updateKyc() { return this.serverUrl + 'accounts/update_kyc/'; } // update kyc url
    get verifyOtp() { return this.serverUrl + 'accounts/otp_request/'; }
    get profileImage() { return this.serverUrl + 'v2/orders/media/profile_images/'; }
    get setBiometrics() { return this.serverUrl + 'accounts/set_biometric/' }
    get oauthGrant() { return this.serverUrl + 'accounts/grant/'; }
    get checkTokenExpirationUrl() { return this.serverUrl + 'accounts/check_reset_token_validity/'; }

    // SISL Wealth Client URL
    get sislWealthClientUrl() { return this.serverUrl + 'third_party/investwell/sso_token'; }

    // Get Help Links
    get links() { return this.serverUrl + 'static_data/links/'; }
    get marketConnectivityUrl() { return this.serverUrl + 'static_data/market_session/'; }

    // Indices Url
    get getUserIndices() { return this.serverUrl + 'market_data/indices/'; }
    get getIndicesStaticList() { return this.serverUrl + 'static_data/indices/'; }

    // User Books Url
    get orderBookUrl() { return this.serverUrl + 'v2/orders/filter/'; }
    get cancelOrderUrl() { return this.serverUrl + 'v2/orders/order/'; }
    get getTradeList() { return this.serverUrl + 'v2/orders/trades/'; }
    get getMarginSummaryUrl() { return this.serverUrl + 'v2/orders/margin/'; }
    get getTransactionHistory() { return this.serverUrl + 'v2/orders/transaction_history/'; }
    get getHoldings() { return this.serverUrl + 'v2/orders/holdings/'; }
    get getMTFHoldings() { return this.serverUrl + 'v2/orders/holdings/mtf/'; }
    get getApprovedStockList() { return this.serverUrl + 'static_data/approved_mtf_stock_list/'; }
    get converPosition() { return this.serverUrl + 'v2/orders/product_conversion/'; }
    get productConverionSummary() { return this.serverUrl + 'v2/orders/product_conversion/'; }
    get allOrders() { return this.serverUrl + 'v2/orders/all_orders/'; }
    get getMutualFundHoldings() { return this.serverUrl + 'mutual_fund/holdings'; }
    get gttBookUrl() { return this.serverUrl + 'v2/orders/gttorder/'; }
    get superBookUrl() { return this.rootUrl + "order-engine/api/v1/super-orders/all/" }
    get smartBookUrl() { return this.rootUrl + "order-engine/api/v1/smart-orders/all/" }

    // Order Depth Url
    get getOrderDepth() { return this.serverUrl + 'market_data/depth/'; }

    // Market Watch Url
    get smartPortfolio() { return this.serverUrl + 'market_data/smart_portfolio/'; }
    get marketWatchUrl() { return this.serverUrl + 'market_data/market_watch/'; }
    get singleQuoteUrl() { return this.serverUrl + 'market_data/quotes/quote/'; }

    // Segments Settings Url
    get segmentSettingsUrl() { return this.serverUrl + 'static_data/exchange/segments/'; }

    // Order urls
    get placeOrderUrl() { return this.serverUrl + 'v2/orders/'; }
    get multiLegOrderUrl() { return this.serverUrl + 'v2/orders/multileg/'; }
    get modifyOrderUrl() { return this.placeOrderUrl + 'order/'; }
    get scalperOrder() { return this.placeOrderUrl + 'depth_scalper/'; }
    get cancelAllOrdersUrl() { return this.placeOrderUrl + 'order/all/'; }
    get bocoOrderMslPercent() { return this.serverUrl + 'static_data/boco_msl/'; }
    get downloadBooksUrl() { return this.placeOrderUrl + 'download_books/'; }
    get mediaUrl() { return this.placeOrderUrl + 'media/'; }
    get placeGttOrderUrl() {return this.serverUrl + 'v2/orders/gttorder/';}
    get placeSuperOrderUrl() {return  this.rootUrl + 'order-engine/api/v1/super-orders';}
    get placeSmartOrderUrl() {return  this.rootUrl + 'order-engine/api/v1/smart-orders/';}
    get smartOrderStatusUrl() {return  this.rootUrl + 'order-engine/api/v1/smart-orders/status/';}

    // Search Symbol Url
    get searchSymbolUrl() { return this.serverUrl + 'static_data/symbol_search/'; }
    get searchSpecificSymbolUrl() { return this.serverUrl + 'static_data/symbol_search/ladder/'; }
    get downloadSearchSymbolScript() { return this.serverUrl + `static_data/scrip_master/?r=${new Date().toDateString()}`; }
    get downloadSymbolInfoScript() { return this.serverUrl + `static_data/scrip_info/?r=${new Date().toDateString()}`; }
    get downloadIndicesInfoScript() { return this.serverUrl + `static_data/indices_info/?r=${new Date().toDateString()}`; }
    get singleSymbolData() { return this.serverUrl + `market_data/market_watch/single_symbol_row/`; }
    get specificSymbol() { return this.serverUrl + 'static_data/symbol_details/'; }

    // Banned Symbol Url
    get foBannedSymbolUrl() { return this.serverUrl + 'static_data/v2/fo_banning/'; }

    // AMO URL
    get getAMOData() { return this.serverUrl + 'static_data/amo_timings/'; }

    // CACHE URLS
    get setCacheUrl() { return this.edisServerUrl + 'api/v2/cache/set/'; }
    get getCacheUrl() { return this.edisServerUrl + 'api/v2/cache/get/'; }
    get getAllKeys() { return this.edisServerUrl + 'api/v2/cache/get_all_keys/'; }

    // News Url
    getNewsUrl(symbol: string, callback?: string) {
        return 'https://query.yahooapis.com/v1/public/yql?q=select * from rss where url="https://news.google.com/news/rss/search/section/' +
            'q/' + symbol + '" limit 60 ' + ' &format=json&callback=JSONP_CALLBACK';
    }

    // News/Twitter Api Url
    get getNews() { return this.serverUrl + 'third_party/news'; }
    get getTweets() { return this.serverUrl + 'third_party/tweets'; }
    get getChartingData() { return this.serverUrl + 'market_data/candles/'; }
    get getConfigParams() { return this.serverUrl + 'static_data/config_params/'; }
    get getBrokerDetails() { return this.serverUrl + 'static_data/broker_details/'; }

    // Message bar Urls
    get broadcastMessage() { return this.serverUrl + 'v2/orders/broadcast_messages/'; }

    // Batch Order Urls
    get executeBatchOrder() { return this.serverUrl + 'v2/orders/batch_orders/'; }
    get uploadBatchFile() { return this.serverUrl + 'v2/orders/file_upload/'; }

    // Symbol Info. Url
    get getSymbolInfo() { return this.serverUrl + 'static_data/symbol_info/'; }

    get linkUrl() { return this.serverUrl + 'static_data/links/'; }

    get geolocationAPIUrl() {return 'https://api.ipify.org?format=json'};

    //BackOfficeData url
    get BackOfficeData() { return this.serverUrl + 'static_data/back_office/' }

    get twoFAToken() { return this.serverUrl + 'accounts/verify_persistance/' }

    get logger() { return this.serverUrl + 'logger/log/'; }

    get updatePushToken() {
        return this.serverUrl + 'third_party/update_push_token';
    }

    // Funds Deposit/Withdrwal
    get depositFunds() { return this.serverUrl + 'third_party/cash/deposit/'; }
    get withdrawFunds() { return this.serverUrl + 'third_party/cash/withdraw/'; }
    get cancelWithdrawFunds() { return this.serverUrl + 'third_party/cash/cancel_withdraw/'; }
    get getBankAccounts() { return this.serverUrl + 'third_party/cash/banks/'; }
    get getFundsReports() { return this.serverUrl + 'third_party/cash/transactions/'; }
    get verifyPayments() { return this.serverUrl + 'third_party/cash/verify/'; }
    get checkVpa() { return this.serverUrl + 'third_party/cash/hdfc/upi/checkVpa/'; }

    //quick links
    get getQuickLinks() { return this.serverUrl + 'third_party/silent_login/'; }
    
    // Market Analytics Url
    get getMostActiveUrl() { return this.serverUrl + 'market_data/most_active/'; }
    get getTopGainersLosersUrl() { return this.serverUrl + 'market_data/top_gainer_loser/'; }

    // EDIS URLS
    get getEDISAuthorizeUrl() { return this.edisServerUrl + 'edis/verify/encrypt/'; }
    get getEDISUnAuthorizeUrl() { return this.edisServerUrl + 'edis/cancel_transaction/encrypt'; }
    get getEDISRegenerateTPINUrl() { return this.edisServerUrl + 'edis/pin/regenerate/'; }
    get getEDISConfirmStatusUrl() { return this.edisServerUrl + 'edis/report/status/'; }
    get getPledgeEncryptUrl() { return this.edisServerUrl + 'margin/pledge/encrypt/'; }
    get getMutualFundPledgeEncryptUrl() { return this.edisServerUrl + 'margin/pledge/mutualfund/encrypt/'; }
    get getPledgeSConfirmStatusUrl() { return this.edisServerUrl + 'margin/report/status/v2/'; }
    get verifyPledgeableQuantityUrl() { return this.serverUrl + 'v2/orders/verify_pledge/'; }
    get getEDISRedirectionPage() { return this.edisServerUrl + 'edis/verify/redirect'; }
    get getEDISStatusUrl() { return this.edisServerUrl + 'edis/verify/get_edis_status/'; }
    get getEDISFreezeCancelQuantityUrl() { return this.edisServerUrl + 'edis/cancel_transaction/revoke'; }

    // IPO URLS
    get getIPOListUrl() { return this.edisServerUrl + 'ipo/list/all/'; }
    get placeIPOOrder() { return this.edisServerUrl + 'ipo/order/place_order'; }
    get getIPOOrderBook() { return this.edisServerUrl + 'ipo/download/orders'; }
    get goConfig() { return this.edisServerUrl + 'api/v2/cache/get_config'; }

    //BROKERAGE URL
    get getBrokerageUrl() { return this.edisServerUrl + 'brokerage/' }

    //SPREAD SYMBOL URL
    get getSpreadDataUrl() { return this.edisServerUrl + 'spread_data/' }

    //REPORTS URL
    get getHoldingReportsUrl() { return this.edisServerUrl + 'back_office/holding' }
    get getDpTransactionUrl() { return this.edisServerUrl + 'back_office/dp_transaction' }
    get getFinanicalLedgerUrl() { return this.edisServerUrl + 'back_office/finanical_ledger' }
    get getFundsSummaryUrl() { return this.edisServerUrl + 'back_office/funds_summary' }
    get getTradesUrl() { return this.edisServerUrl + 'back_office/trades' }
    get getPositionsUrl() { return this.edisServerUrl + 'back_office/net_positons' }
    get getMTMBillUrl() { return this.edisServerUrl + 'back_office/daily_mtmBill' }
    get getFIFOUrl() { return this.edisServerUrl + 'back_office/client_fifo' }

    // CONTRACT URL
    get getMultiContractDocument() {return this.edisServerUrl + 'back_office/multi_contract_notes/';}
    get getContractDocument() { return this.edisServerUrl + 'back_office/contract_notes/'; }
    downloadContractUrl(url: string) { return SharedUtils.getContractNoteDownloadUrl(url,this.edisServerUrl); }

    get getDownloadHoldingReportsUrl() { return this.edisServerUrl + 'back_office/holding/download' }
    get getDownloadTradesUrl() { return this.edisServerUrl + 'back_office/trades/download' }
    get getDownloadDpTransactionUrl() { return this.edisServerUrl + 'back_office/dp_transaction/download' }
    get getDownloadFinanicalLedgerUrl() { return this.edisServerUrl + 'back_office/finanical_ledger/download' }
    get getDownloadFundsSummaryUrl() { return this.edisServerUrl + 'back_office/funds_summary/download' }
    get getDownloadPositionsUrl() { return this.edisServerUrl + 'back_office/net_positons/download' }
    get getDownloadMTMBillUrl() { return this.edisServerUrl + 'back_office/daily_mtmBill/download' }
    get getDownloadClientFIFOurl() { return this.edisServerUrl + 'back_office/client_fifo/download' }

    getKycUrl(url: string) {
        const orgUrl = new URL(url);
        orgUrl.searchParams.set('useNativeCam', 'true');
        orgUrl.searchParams.set('target', 'app');
        orgUrl.searchParams.set('hideHeader', 'true');
        return orgUrl.toString();
    }

    // ESCALATION URL
    get getEscalationDataUrl() { return this.edisServerUrl + 'escalation/' }

    // TOTP URL
    get getValidateTotpUrl() { return this.serverUrl + 'accounts/validate_totp/' }
    get getVerifyPasswordUrl() { return this.serverUrl + 'accounts/verify_password/' }

    //REST URL
    get getRestUserDetails() { return this.restServerUrl + 'accounts/connect/' }
    get getRestLoginUrl() { return this.restServerUrl + 'accounts/connect/login/validate/' }
    get getVerifyRestTotpOtp() { return this.restServerUrl + 'accounts/connect/otp/verify/' }


    // qr code otp  url
    getSecretUri(issuer: string, secretKey: string) {
        // TIME STEP  is the the time in seconds after which totp will change in 
        // the authenticator application .
        // Issuer :  is the username 
        // URI is in the format which isused for  parsing secret for the otp and 
        // totp purpose 
        const uri = `otpauth://totp/${issuer}?secret=${secretKey}&issuer=${SELECTED_VENDOR.name}`;
        return uri
    }

    //REG URL
    get sendRegActionUrl() { return this.serverUrl + 'log-regulatory/' }

    // ANALYTICS URL
    get getSymbolAnalyticsUrl() { return this.analyticsServerUrl + "market_analyzer/get_companies_details" }

    // INDEX URL
    get getIndexStockDataUrl() { return this.analyticsServerUrl + "market_analyzer/get_companies_by_index_name?index_name=" }

    // SCREENER URL
    get screenerUrl() { return this.analyticsServerUrl + "screener/" }
    get getRecentScreenersUrl() { return this.screenerUrl + "list-screeners" }
    get getStarredScreenersUrl() { return this.screenerUrl + "list-starred-screeners" }
    get getScreenerUrl() { return this.screenerUrl + "get-screener" }
    get toggleStarScreenerUrl() { return this.screenerUrl + "toggle-star-screener" }
    get deleteScreenerUrl() { return this.screenerUrl + "delete-screener" }

    // AGENTS URL
    get createScreenerUrl() { return this.analyticsServerUrl + "agents/create-screener-from-nlp" }

    // STOCK SIP URL
    get getStockSipUrl() { return this.serverUrl + "sip/" }
    get getSipTransactionsUrl() { return this.serverUrl + "sip/transaction-details/" }

    // QUOTE API URL
    get getQuoteApiUrl() { return this.serverUrl + "static_data/symbols/first_fetch/" }
}

export let applicationUrls = ApplicationUrls.getInstance();

